enum ChannelPartnerType {
  Individual = 'Individual',
  Company = 'Company',
}

export default ChannelPartnerType;
